import { ListItemText } from '@mui/material';
import Can from 'components/Can';
import { Link } from 'react-router-dom';
import { ListItemNavButton, NavListItemIcon, renderIcon } from './DashboardLayout';

interface MenuItem {
  module: string;
  name: string;
  link: string;
  icon: string;
}
const SingleNavItem = ({
  menu,
  open,
  onCloseDrawer
}: {
  menu: MenuItem;
  open: boolean;
  onCloseDrawer?: () => void;
}) => (
  <Can I="read" module={menu.module} key={menu.name}>
    <Link
      to={menu.link}
      onClick={() => {
        if (onCloseDrawer) onCloseDrawer();
      }}>
      <ListItemNavButton key={menu.name}>
        <NavListItemIcon title={!open ? menu.name : undefined}>
          {renderIcon(menu.icon)}
        </NavListItemIcon>
        <ListItemText primary={menu.name} sx={{ display: open ? 'block' : 'none' }} />
      </ListItemNavButton>
    </Link>
  </Can>
);

export default SingleNavItem;
